import { useState, useEffect } from 'react';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from '../utils/firebase';

/**
 * Custom hook to fetch the latest system statistics from Firestore
 * @returns {Object} Object containing systemStats data, loading state, and error
 */
function useSystemStats() {
  const [systemStats, setSystemStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLatestStats = async () => {
      try {
        setLoading(true);
        setError(null);

        // Query to get the latest systemStats record
        const statsRef = collection(db, 'systemStats');
        const statsQuery = query(statsRef, orderBy('date', 'desc'), limit(1));

        const querySnapshot = await getDocs(statsQuery);

        if (!querySnapshot.empty) {
          const latestDoc = querySnapshot.docs[0];
          const data = latestDoc.data();
          setSystemStats({
            id: latestDoc.id,
            ...data,
            // Convert timestamp if it exists
            timestamp: data.timestamp?.__time__
              ? new Date(data.timestamp.__time__)
              : data.timestamp?.toDate?.() || null,
          });
        } else {
          setSystemStats(null);
        }
      } catch (err) {
        console.error('Error fetching system stats:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchLatestStats();
  }, []);

  return { systemStats, loading, error };
}

export default useSystemStats;
